import React, { Component } from "react";
import { NavLink, Route, withRouter, Switch, Redirect } from "react-router-dom";
import { Grid, Menu, Segment, List, Header } from "semantic-ui-react";
import { connect } from "react-redux";


import Links from "./CodeDialer"

import AboutPage from "./About"


class CodeDialerHome extends Component {
  state = { activeItem: "CodeDialer Links" };

  handleItemClick = (e, { name }) => this.setState({ activeItem: name });

  render() {
    const { match } = this.props;
    const { activeItem } = this.state;
    return (
      <div>
        <Grid stackable columns={2} divided='vertically'>
          <Grid.Row>


            <Menu attached='top' tabular>
              <Menu.Item
                name="About"
                as={NavLink}
                exact
                to={`${match.url}/about`}
                active={activeItem === "CodeDialer About"}
                onClick={this.handleItemClick}
              />
              <Menu.Item
                name="CodeDialer Links"
                as={NavLink}
                exact
                to={`${match.url}/links`}
                active={activeItem === "CodeDialer Links"}
                onClick={this.handleItemClick}
              />
            </Menu>


            <Segment attached='bottom'>
              <Switch>
                <Route
                  exact
                  path={`${match.path}/about`}
                  component={AboutPage}
                />
                <Route
                  exact
                  path={`${match.path}/links`}
                  component={Links}
                />
                <Redirect to={`${match.path}/code_dialer`} />
              </Switch>
            </Segment>

          </Grid.Row>

        </Grid>
      </div>
    )
  }
}

export default CodeDialerHome;
